/**
 * Render the blocks.
 */
/* eslint-env jquery */
import classnames from 'classnames';
import Title from './components/Title';
import HowToChildDesc from './components/HowToChildDesc';
import HowToChildPositionClasses from './classes';
import HowToChildSeparator from './components/HowToChildSeparator';
import CallToAction from './components/CallToAction';
import HowToChildIconImage from './components/HowToChildIconImage';
import { __ } from '@wordpress/i18n';
import { MediaUpload } from '@wordpress/block-editor';
import { Button } from '@wordpress/components';
import styles from './editor.lazy.scss';
import {useLayoutEffect} from "react";

/* eslint-disable no-unused-vars */
let imageSizeOptions = [
	{ value: 'thumbnail', label: __('Thumbnail') },
	{ value: 'medium', label: __('Medium') },
	{ value: 'full', label: __('Large') },
];

const Render = (props) => {
	useLayoutEffect(() => {
		styles.use();
		return () => {
			styles.unuse();
		};
	}, []);
	props = props.parentProps;

	const { className, setAttributes, attributes } = props;

	// Setup the attributes.
	const {
		iconimgPosition,
		seperatorPosition,
		seperatorStyle,
		ctaType,
		iconImage,
		showTitle,
		showDesc,
	} = attributes;

	/*
	 * Event to set Image as while adding.
	 */
	const onSelectImage = (media) => {
		if (!media || !media.url) {
			setAttributes({ iconImage: null });
			return;
		}

		if (!media.type || 'image' !== media.type) {
			setAttributes({ iconImage: null });
			return;
		}
		if (media.sizes) {
			const newImg = getImageSize(media.sizes);
			imageSizeOptions = newImg;
		}
		setAttributes({ iconImage: media });
	};

	const getImageSize = (sizes) => {
		const sizeArr = [];
		jQuery.each(sizes, function (index) {
			const name = index;
			const p = { value: name, label: name };
			sizeArr.push(p);
		});
		return sizeArr;
	};

	if (iconImage && iconImage.sizes) {
		imageSizeOptions = getImageSize(iconImage.sizes);
	}

	let imageName = __('Select Image');
	if (iconImage) {
		if (iconImage.url === null || iconImage.url === '') {
			imageName = __('Select Image');
		} else {
			imageName = __('Replace Image');
		}
	}

	// Get Image components.
	const isImage = <HowToChildIconImage attributes={attributes} />;

	let iconImagehtml = isImage;
	let seperatorPositions = seperatorPosition;
	const seperatorHtml = <HowToChildSeparator attributes={attributes} />;
	let showSeperator = true;

	if (
		seperatorPosition === 'after_icon' &&
		(iconimgPosition === 'above-title' || iconimgPosition === 'below-title')
	) {
		showSeperator = false;
		iconImagehtml = (
			<>
				{isImage}
				{'none' !== seperatorStyle && seperatorHtml}
			</>
		);
	}

	if (
		seperatorPosition === 'after_icon' &&
		(iconimgPosition !== 'above-title' || iconimgPosition !== 'below-title')
	) {
		seperatorPositions = 'after_title';
	}

	if (
		iconimgPosition === 'below-title' &&
		seperatorPosition === 'after_title'
	) {
		showSeperator = false;
		iconImagehtml = (
			<>
				{'none' !== seperatorStyle && seperatorHtml}
				{isImage}
			</>
		);
	}

	// Get description and seperator components.
	const desc = (
		<>
			{'none' !== seperatorStyle &&
				seperatorPositions === 'after_title' &&
				showSeperator &&
				seperatorHtml}
			<div className="wpsp-ifb-text-wrap">
				{showDesc && (
					<HowToChildDesc
						attributes={attributes}
						setAttributes={setAttributes}
						props={props}
					/>
				)}
				{'none' !== seperatorStyle &&
					seperatorPositions === 'after_desc' &&
					seperatorHtml}
				<CallToAction
					attributes={attributes}
					setAttributes={setAttributes}
				/>
			</div>
		</>
	);

	// Get Title components.
	const titleText = (
		<>
			<div className="wpsp-ifb-title-wrap">
				{showTitle && (
					<Title
						attributes={attributes}
						setAttributes={setAttributes}
						props={props}
					/>
				)}
			</div>
		</>
	);

	const output = (
		<div
			className={classnames(
				'wpsp-how-to__content-wrap',
				ctaType === 'all' ? ' wpsp-how-to_cta-type-all' : '',
				...HowToChildPositionClasses(attributes)
			)}
		>
			<div className="wpsp-ifb-content">
				{iconimgPosition === 'above-title' && (
					<>
						{iconImagehtml}
						<MediaUpload
							title={__('Select Image')}
							onSelect={onSelectImage}
							allowedTypes={['image']}
							value={iconImage}
							render={({ open }) => (
								<Button isDefault onClick={open}>
									{imageName}
								</Button>
							)}
						/>
						{iconImage.url && (
							<Button
								className="wpsp-rm-btn"
								onClick={() => setAttributes({ iconImage: '' })}
								isLink
								isDestructive
							>
								{__('Remove Image')}
							</Button>
						)}
						{titleText}
						{desc}
					</>
				)}

				{iconimgPosition === 'below-title' && (
					<>
						{titleText}
						{iconImagehtml}
						<MediaUpload
							title={__('Select Image')}
							onSelect={onSelectImage}
							allowedTypes={['image']}
							value={iconImage}
							render={({ open }) => (
								<Button isDefault onClick={open}>
									{imageName}
								</Button>
							)}
						/>
						{iconImage.url && (
							<Button
								className="wpsp-rm-btn"
								onClick={() => setAttributes({ iconImage: '' })}
								isLink
								isDestructive
							>
								{__('Remove Image')}
							</Button>
						)}
						{desc}
					</>
				)}

				{iconimgPosition === 'below-desc' && (
					<>
						{titleText}
						{desc}
						{iconImagehtml}
						<MediaUpload
							title={__('Select Image')}
							onSelect={onSelectImage}
							allowedTypes={['image']}
							value={iconImage}
							render={({ open }) => (
								<Button isDefault onClick={open}>
									{imageName}
								</Button>
							)}
						/>
						{iconImage.url && (
							<Button
								className="wpsp-rm-btn"
								onClick={() => setAttributes({ iconImage: '' })}
								isLink
								isDestructive
							>
								{__('Remove Image')}
							</Button>
						)}
					</>
				)}
			</div>
		</div>
	);
	/* eslint-disable  jsx-a11y/anchor-has-content, jsx-a11y/anchor-is-valid */
	return (
		<>
			<div
				className={classnames(
					className,
					'wpsp-howto-child__outer-wrap',
					`wpsp-block-${props.clientId.substr(0, 8)}`
				)}
			>
				{ctaType === 'all' && (
					<>
						<a
							className="wpsp-howto-child-link-wrap wpsp-how-to__link-to-all"
							aria-label={'HowToChild Link'}
							rel="noopener noreferrer"
						></a>
						{output}
					</>
				)}
				{ctaType !== 'all' && output}
			</div>
		</>
	);
};
export default Render;
